import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { heroImages } from "../data/mock";

const NotFound = () => (
  <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
    <img src={heroImages[0].img} alt="" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-[#0a1f33]/85" />
    <div className="relative z-10 text-center px-6">
      <p className="font-display text-7xl md:text-9xl text-[#f5a524]">404</p>
      <h1 className="font-heading text-3xl text-white mt-2">This one got away.</h1>
      <p className="text-slate-300 mt-2 max-w-md mx-auto">The page you're looking for isn't here — but the fish are still biting.</p>
      <Link to="/"><Button className="btn-gold mt-6 h-12 px-8">Back to home</Button></Link>
    </div>
  </section>
);

export default NotFound;
